import {
  DataTable,
  PageLoading,
  Pagination,
  PaginationState,
} from '@/components';
import { Info } from 'lucide-react';
import { ColumnDef } from '@tanstack/react-table';
import { UserRole } from '@/feature/users/constants';
import { Dispatch, SetStateAction } from 'react';
import { startCase } from 'lodash';

interface ProfileUser {
  id: string;
  firstName: string;
  lastName: string;
  role: UserRole;
}

interface OrgProfileUsersTableProps {
  users: ProfileUser[];
  totalCount: number;
  isLoading?: boolean;
  pagination: PaginationState;
  setPagination: Dispatch<SetStateAction<PaginationState>>;
}

const columns: ColumnDef<ProfileUser>[] = [
  {
    accessorKey: 'name',
    header: 'User',
    cell: ({ row }) => (
      <div>
        {row.original.firstName} {row.original.lastName}
      </div>
    ),
  },
  {
    accessorKey: 'role',
    header: 'Role',
    cell: ({ row }) => startCase(row.original.role.toLowerCase()),
  },
];

export const OrgProfileUsersTable = ({
  users,
  totalCount,
  isLoading,
  pagination,
  setPagination,
}: OrgProfileUsersTableProps) => {
  return (
    <div className="mb-10">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-lg font-semibold">
          Users with this profile ({totalCount})
        </h2>
        <div className="text-muted-foreground flex items-center gap-2 text-sm">
          <Info className="size-4" />
          <span>
            Manage user profile assignment from the individual user settings
          </span>
        </div>
      </div>

      {isLoading ? (
        <PageLoading className="rounded-md border py-8" />
      ) : (
        <>
          <DataTable columns={columns} data={users} />
          <div className="mt-4">
            <Pagination
              pagination={pagination}
              setPagination={setPagination}
              totalCount={totalCount}
              pageSizeOptions={[5, 10, 15]}
            />
          </div>
        </>
      )}
    </div>
  );
};
